export const REFRESH_STORE = 'REFRESH_STORE'
export const VALIDATE_PASSWORD = 'VALIDATE_PASSWORD'
export const VALIDATE_PASSWORD_SUCCESS = 'VALIDATE_PASSWORD_SUCCESS'
export const VALIDATE_PASSWORD_ERROR = 'VALIDATE_PASSWORD_ERROR'

export const CHANGE_OPEN_WIZARD = 'CHANGE_OPEN_WIZARD'
export const COMPLETE_WIZARD = 'COMPLETE_WIZARD'